import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import OwaspTrainingSetup from './OwaspTrainingSetup';
import OwaspTrainingQuiz from './OwaspTrainingQuiz';
import OwaspTrainingResults from './OwaspTrainingResults';
import { generateOwaspModule } from './owaspTrainingApi';
import { mapAiToQuestion } from './mapAiToQuestion';
import './owasp-training-demo.scss';

const STEPS = {
    setup: 'setup',
    quiz: 'quiz',
    results: 'results',
};

export default function OwaspTrainingDemo() {
    const [step, setStep] = useState(STEPS.setup);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [question, setQuestion] = useState(null);
    const [blockValues, setBlockValues] = useState({});
    const [qaWarnings, setQaWarnings] = useState([]);

    const handleGenerate = async (payload) => {
        setLoading(true);
        setError(null);
        try {
            const data = await generateOwaspModule(payload);
            const mapped = mapAiToQuestion(data.module, data.meta || payload);
            setQuestion(mapped);
            setQaWarnings(
                data.qa && !data.qa.pass && Array.isArray(data.qa.issues)
                    ? data.qa.issues
                    : []
            );
            setStep(STEPS.quiz);
        } catch (e) {
            setError(e.message || 'Failed to generate module');
        } finally {
            setLoading(false);
        }
    };

    const handleRestart = () => {
        setStep(STEPS.setup);
        setQuestion(null);
        setBlockValues({});
        setQaWarnings([]);
        setError(null);
    };

    const handleFinish = (values) => {
        setBlockValues(values);
        setStep(STEPS.results);
    };

    return (
        <div className="owasp-training-demo-page">
            <Helmet>
                <title>OWASP Training (Demo) | AwareGO</title>
            </Helmet>
            <div className="owasp-demo-inner">
                <p className="owasp-demo-brand">AwareGO · OWASP Training Demo</p>

                {loading ? (
                    <div className="owasp-demo-loading">
                        <ThemedSpinner />
                        <p>Generating your personalized module…</p>
                    </div>
                ) : null}

                {!loading && step === STEPS.setup ? (
                    <OwaspTrainingSetup
                        onGenerate={handleGenerate}
                        loading={loading}
                        error={error}
                    />
                ) : null}

                {!loading && step === STEPS.quiz && question ? (
                    <OwaspTrainingQuiz
                        question={question}
                        onFinish={handleFinish}
                        onRestart={handleRestart}
                    />
                ) : null}

                {!loading && step === STEPS.results && question ? (
                    <OwaspTrainingResults
                        question={question}
                        blockValues={blockValues}
                        qaWarnings={qaWarnings}
                        onRestart={handleRestart}
                    />
                ) : null}
            </div>
        </div>
    );
}
